import React from "react";
import TableCell from "./TableCell";

const TableContent = ({
  table,
  activeColumns,
  isColumnPinned,
  getPinnedColumnStyle,
  columnConditions,
  isAnalyticsTable,
  upperValue,
  lowerValue,
  formatDateForInput,
  cellEditingManager,
  dropdownData,
}) => {
  return (
    <tbody className="bg-white divide-y divide-gray-200">
      {table.getRowModel().rows.map((row) => (
        <tr
          key={row.id}
          className="hover:bg-gray-100"
          style={{ height: "25px" }}
        >
          {row.getVisibleCells().map((cell) => (
            <TableCell
              key={cell.id}
              cell={cell}
              rowData={row.original}
              activeColumns={activeColumns}
              isColumnPinned={isColumnPinned}
              getPinnedColumnStyle={getPinnedColumnStyle}
              columnConditions={columnConditions}
              isAnalyticsTable={isAnalyticsTable}
              upperValue={upperValue}
              lowerValue={lowerValue}
              formatDateForInput={formatDateForInput}
              editingCell={cellEditingManager.editingCell}
              editRef={cellEditingManager.editRef}
              startEditingCell={cellEditingManager.startEditingCell}
              onCommitEdit={cellEditingManager.commitCellUpdate}
              setEditingCell={cellEditingManager.setEditingCell}
              tempValue={cellEditingManager.tempValue}
              setTempValue={cellEditingManager.setTempValue}
              companies={dropdownData?.companies}
              teams={dropdownData?.teams}
              departments={dropdownData?.departments}
              positions={dropdownData?.positions}
            />
          ))}
        </tr>
      ))}
    </tbody>
  );
};

export default TableContent;
